'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Fragment } from 'react';
import { GRID_BREAKPOINT_SMALL, GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import ApiError from '../Errors/ApiError';
import InProgressSection from '../InProgress/InProgressSection';
import RecommendationsContainer from '../../containers/RecommendationsContainer';
import useWootricSurvey from '../../hooks/useWootricSurvey';
import { device } from '../../constants/StyledComponentConstants';
import { academyPageFullWidth } from '../../utils/Styling';
const RecommendationsArea = styled.div.withConfig({
  displayName: "HomePageLayout__RecommendationsArea",
  componentId: "sc-1kboa6d-0"
})(["margin-bottom:46px;@media screen and ", "{margin-bottom:4px;}"], device.mobile);
/* Removes border at top of UIDashboard Page */

const HomePageWrapper = styled.div.withConfig({
  displayName: "HomePageLayout__HomePageWrapper",
  componentId: "sc-1kboa6d-1"
})(["width:100%;"]);
const InnerWrapper = styled.div.withConfig({
  displayName: "HomePageLayout__InnerWrapper",
  componentId: "sc-1kboa6d-2"
})(["", " padding:0 48px;overflow:hidden;@media (max-width:", "){padding:0 24px;}@media (max-width:", "){padding:0 12px;}"], academyPageFullWidth, GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_SMALL);

const HomePageLayout = ({
  children,
  error,
  footerComponent
}) => {
  useWootricSurvey();
  return /*#__PURE__*/_jsxs(HomePageWrapper, {
    children: [/*#__PURE__*/_jsx(InnerWrapper, {
      children: error ? /*#__PURE__*/_jsx(ApiError, {
        className: "tracks-api-error",
        error: error,
        marker404: "HOMEPAGE_API_404",
        markerDefault: "HOMEPAGE_API_ERROR",
        resetLink: '/'
      }) : /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(InProgressSection, {}), /*#__PURE__*/_jsx(RecommendationsArea, {
          "data-test-id": "pre-catalog-cards-container",
          children: /*#__PURE__*/_jsx(RecommendationsContainer, {})
        }), children]
      })
    }), !error && footerComponent]
  });
};

HomePageLayout.propTypes = {
  children: PropTypes.node,
  error: PropTypes.object,
  footerComponent: PropTypes.node
};
export default HomePageLayout;